<template>
	<div class="detail_page" v-loading="loadingMask">
		<div class="position ">
			<div class="w1">当前位置：
				<router-link :to="'home'">首页</router-link>>
				<a v-if="arrNodetreeid.length>0" style="text-decoration: none;">{{arrNodetreename[0]}}</a>
				<!-- <router-link v-if="arrNodetreeid.length>0"
					:to="'list?id='+arrNodetreeid[0]">{{arrNodetreename[0]}}</router-link> -->
			</div>
		</div>


		<div class="w1"><!--w1 -->





			<div class="wrap_group1  mb_1"><!--wrap_group1 -->
				<div class="wrap_group1_R"><!--wrap_group1_R -->


					<div class="main_title">{{articleTitle}}</div>

					<div class="main_title_info">发布日期：{{articleDate}}</div>

					<div class="main_text" v-html="articleHtml"><!--main_text -->
					</div><!--/main_text -->

					<div class="main_source">来源：<span v-html="articleSource"></span></div>	








				</div><!--/index_group1_R -->
			</div><!--/wrap_group1 -->



		</div><!--/w1 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				articleId: "",
				articleTitle: "",
				articleDate: "",
				articleHtml: "",
				articleSource: "",
				arrNodetreeid: [],
				arrNodetreename: [],
			}
		},
		components: {

		},
		created: function() {
			this.getArticle();
		},
		mounted: function() {

		},
		methods: {
			getArticle: function() {
				this.loadingMask = true;
				var _this = this;
				_this.articleId = this.$route.query.id;
				this.$http({
						method: 'get',
						url: '/chinaculturalindustrypromotion/tbapparticleinfo/info/' + _this.articleId,
						responseType: 'json',
						params: {

						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							//console.log(response.data);
							_this.articleTitle = response.data.tbapparticleinfo.fdarticletitle;
							_this.articleDate = response.data.tbapparticleinfo.fdpublishtime.substring(0, 10);
							//处理视频和pdf
							var temphtml = response.data.tbapparticleinfo.fdhtmlcontent;
							if (process.env.NODE_ENV === 'development') {
								temphtml = temphtml.replace(/\/web\/tbappattachments/g, '/proxyapi/web/tbappattachments');
							}
							if (temphtml.indexOf("/web/tbappattachments/getFile?filetype=") > -1) {
								// debugger
								var regtaga = RegExp(/<a.*?a>/g);
								var temphtmlarr = temphtml.match(regtaga);
								if (temphtmlarr) {
									for (var i = 0; i < temphtmlarr.length; i++) {
										if (temphtmlarr[i].indexOf("filetype=video") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											tempsrc = tempsrc.replace("getFile", "getVideo");
											temphtml = temphtml.replace(temphtmlarr[i], "<video controls='controls' width='100%' src='" +
												tempsrc + "'></video>");
										} else if (temphtmlarr[i].indexOf("filetype=pdf") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											temphtml = temphtml.replace(temphtmlarr[i],
												"<iframe id='documentViewer' src='/pdfjs/web/viewer.html?file=" + encodeURIComponent(
													tempsrc) + "' style='width:100%;height:8rem;'></iframe>");
										}
									}
								}
							}
							_this.articleHtml = temphtml;
							_this.articleSource = response.data.tbapparticleinfo.fdsource;
							_this.arrNodetreeid = response.data.nodepath.split("/").slice(1);
							_this.arrNodetreename = response.data.channnelname.split("|");
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						alert('数据获取出错！');
					});
			},
		}
	}
</script>

<style>
</style>